/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Quote
 */
export interface Quote {
    /**
     * 
     * @type {string}
     * @memberof Quote
     */
    applicationReference?: string;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    approvedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    interest?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    tenor?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    effectiveInterest?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    monthlyCost?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    consolidationDemand?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    adminFee?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    arrangementFee?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    monthlyAccountFee?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    totalRepaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Quote
     */
    totalFeesAndInterest?: number;
}

/**
 * Check if a given object implements the Quote interface.
 */
export function instanceOfQuote(value: object): value is Quote {
    return true;
}

export function QuoteFromJSON(json: any): Quote {
    return QuoteFromJSONTyped(json, false);
}

export function QuoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Quote {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationReference': json['applicationReference'] == null ? undefined : json['applicationReference'],
        'approvedAmount': json['approvedAmount'] == null ? undefined : json['approvedAmount'],
        'interest': json['interest'] == null ? undefined : json['interest'],
        'tenor': json['tenor'] == null ? undefined : json['tenor'],
        'effectiveInterest': json['effectiveInterest'] == null ? undefined : json['effectiveInterest'],
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'consolidationDemand': json['consolidationDemand'] == null ? undefined : json['consolidationDemand'],
        'adminFee': json['adminFee'] == null ? undefined : json['adminFee'],
        'arrangementFee': json['arrangementFee'] == null ? undefined : json['arrangementFee'],
        'monthlyAccountFee': json['monthlyAccountFee'] == null ? undefined : json['monthlyAccountFee'],
        'totalRepaymentAmount': json['totalRepaymentAmount'] == null ? undefined : json['totalRepaymentAmount'],
        'totalFeesAndInterest': json['totalFeesAndInterest'] == null ? undefined : json['totalFeesAndInterest'],
    };
}

export function QuoteToJSON(json: any): Quote {
    return QuoteToJSONTyped(json, false);
}

export function QuoteToJSONTyped(value?: Quote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationReference': value['applicationReference'],
        'approvedAmount': value['approvedAmount'],
        'interest': value['interest'],
        'tenor': value['tenor'],
        'effectiveInterest': value['effectiveInterest'],
        'monthlyCost': value['monthlyCost'],
        'consolidationDemand': value['consolidationDemand'],
        'adminFee': value['adminFee'],
        'arrangementFee': value['arrangementFee'],
        'monthlyAccountFee': value['monthlyAccountFee'],
        'totalRepaymentAmount': value['totalRepaymentAmount'],
        'totalFeesAndInterest': value['totalFeesAndInterest'],
    };
}

